import React from 'react';
import { AccountCircle } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { Badge, Box } from '@mui/material';

// StatusBadge component for notification icon
export default function StatusBadge({ status }) {
  const iconStyle = {
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    lineHeight: 1,
  };

  const badgeStyle = {
    '& .MuiBadge-badge': {
      padding: 0,
      minWidth: 'auto',
      height: 'auto',
    }
  };

  switch (status) {
    case 'success':
      return (
        <Badge 
          sx={badgeStyle}
          badgeContent={
            <Box sx={iconStyle}>
              <CheckCircleIcon color="success" sx={{ fontSize: 24 }} />
            </Box>
          }
        >
          <AccountCircle style={{ fontSize: '2rem' }} />
        </Badge>
      );
    case 'warning':
      return (
        <Badge 
          sx={badgeStyle}
          badgeContent={
            <Box sx={iconStyle}>
              <WarningIcon color="warning" sx={{ fontSize: 24 }} />
            </Box>
          }
        >
          <AccountCircle style={{ fontSize: '2rem' }} />
        </Badge>
      );
    case 'failed':
    case 'error':
      return (
        <Badge 
          sx={badgeStyle}
          badgeContent={
            <Box sx={iconStyle}>
              <ErrorIcon color="error" sx={{ fontSize: 24 }} />
            </Box>
          }
        >
          <AccountCircle style={{ fontSize: '2rem' }} />
        </Badge>
      );
    default:
      return <AccountCircle style={{ fontSize: '2rem' }} />;
  }
}
